/**
 * Every Firebase Auth in the web app starts here, on localStorage.
 *
 * getAuth() starts on [IndexedDB, localStorage, sessionStorage]: on every page load it moved the
 * signed-in user from localStorage into IndexedDB and removed the localStorage key, and a later
 * setPersistence(local) moved it back. In between, every other open tab of the app read "signed out"
 * and bounced to /login. With localStorage first the user is found where it already is and nothing
 * moves; IndexedDB second only picks up a user stored there by older code. initializeAuth does not add
 * the popup resolver that getAuth adds, and Google sign-in needs it.
 */
import type { FirebaseApp } from 'firebase/app';
import {
  initializeAuth,
  browserLocalPersistence,
  indexedDBLocalPersistence,
  browserPopupRedirectResolver,
  type Auth,
} from 'firebase/auth';

export function startAuth(app: FirebaseApp): Auth {
  return initializeAuth(app, {
    persistence: [browserLocalPersistence, indexedDBLocalPersistence],
    popupRedirectResolver: browserPopupRedirectResolver,
  });
}
